module.exports = __webpack_public_path__ + "img/veterinarian-ua.ff66c1a9.svg";